import dropdown from "./dropdown.vue"

const Dropdown = {
  install(Vue) {
    Vue.component("dropdown", dropdown)
    Vue.prototype.$dropdown = async function(data, target, type = false, offset = 0) {
      try {
        if (!Array.isArray(data)) return false

        if (data.length && typeof data[0] !== "object") {
          data = data.map(item => {
            return { key: item, value: item }
          })
        }

        const promise = await _$.progress.create()

        const $package = {
          data: data,
          target: target,
          type: type,
          offset: offset,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("dropdown", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Dropdown
